export default __webpack_public_path__ + "static/media/122-river-forest.4ff7818e.jpeg";